<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
    <!--here responsiveness has been used commented by Prerna Singh on 21 february 2024-->
  </div>
</div>
<div class="tag_powered_by bottomPowerBy">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class="row">
    <div class="col-md-12">
      <div class="tab_right">
        <div class="container">
          <div class="row middle-row">
            <div class="txt"></div>
            <div class="legendbox legendBoxTop">
              <div style="background-color: #cecece"></div>
              <strong>Asset Idle</strong>
              <div style="background-color: #3fbddd"></div>
              <strong>Asset Running</strong>
              <div style="background-color: #999999"></div>
              <strong>Offline</strong>
              <div style="background-color: #72ff13"></div>
              <strong>Healthy</strong>
              <div style="background-color: #faa700"></div>
              <strong>Unsatisfactory</strong>
              <div style="background-color: #ff2a1b"></div>
              <strong>Unacceptable</strong>
              <div style="background-color: #fcda42"></div>
              <strong>Out for service</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="tab_right">
        {{ lastFileProcessedTime }}
        <!-- <span
          *ngIf="['2','0'].includes(overall_live_status)"
          class="seen"
        >
          <div class="asset_running_dot gray_bg"
             matTooltip="Asset Idle"
            [matTooltipClass]="'tooltip1'"
          ></div>
        </span>
        <span *ngIf="overall_live_status == 1" class="seen">
          <div class="asset_running_dot blue_bg"
             matTooltip="Asset Running"
            [matTooltipClass]="'tooltip1'"
          ></div>
        </span> -->
        <span class="seen">
          <img
            style="width: 20px; height: 20px; cursor: pointer"
            src="./assets/settings.png"
            [matMenuTriggerFor]="menu"
        /></span> 
      </div>
      <mat-menu
        #menu="matMenu"
        class="stroked-menu"
        style="min-height: auto !important"
      >
        <div class="menu-item-container">
          <button
            mat-stroked-button
            (click)="openPlateDetailsModal()"
            color="accent"
            class="details-button stroked-menu-button"
          >
            <mat-icon>info</mat-icon>
            <span>Plate Details</span>
          </button>
        </div>
        <!-- <div class="menu-item-container">
          <button
            (click)="openDeleteModal()"
            mat-stroked-button
            color="warn"
            class="details-button stroked-menu-button"
          >
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </div> -->
      </mat-menu>

      <ul
        ngbNav
        style="
          position: fixed;
          width: 100%;
          background-color: #f7f7f7;
          z-index: 500;
          top: 97px;
        "
        #ctdTabset="ngbNav"
        class="custom_tab nav-v nav-tabs sticky-tab"
      >
        <li [ngbNavItem]="'tab-1'">
          <a ngbNavLink>Monitoring</a>
          <ng-template class="ml-4 mr-4" ngbNavContent style="margin: 0 10px">
            <div class="fixed_status_bar">
              <div class="info_box_outer">
                <div class="info_box" style="width: 25% !important">
                  <h4>{{ company_name }}</h4>
                  <h6>Customer</h6>
                </div>
                <div class="info_box" style="width: 25% !important">
                  <h4>{{ site_id || "N/A" }}</h4>
                  <h6>Site</h6>
                </div>
                <div class="info_box" style="width: 25% !important">
                  <h4>{{ application_id || "N/A" }}</h4>
                  <h6>Application</h6>
                </div>
                <div class="info_box" style="width: 25% !important">
                  <h4>{{ powertrain_name || "N/A" }}</h4>
                  <h6>Powertrain Name</h6>
                </div>
              </div>
            </div>
            <div
              class="flex mb-2 pt-cards-wrapper"
              style="
                margin-top: 105px;
                align-items: stretch;
                width: 99% !important;
                margin-left: 10px;
                flex-direction: row;
              "
              [ngStyle]="{'align-items':client_id==608?'flex-start':'stretch'}"
            >
              <app-power-train
                *ngIf="!loader"
                [subsystem_id]="subsystem_id"
                [overall_status]="overall_live_status"
                class="w-70 pt_image_mail_container"
              ></app-power-train>
              <app-powertrain-anomaly-status
                *ngIf="!loader"
                [subsystem_id]="subsystem_id"
                [asset_ids]="assetIds"
                [device_ids]="inventory_ids"
                [client_id]="client_id"
                [overall_live_status]="overall_live_status"
                [uuid]="uuid"
                class="flex_20"
                style="display: block"
              ></app-powertrain-anomaly-status>
            </div>
            <div
              class="d-flex pt-cards-wrapper"
              style="width: 98%; margin-left: 20px"
            >
              <div class="sensors-table">
                <app-powertrain-sensors-table
                  *ngIf="!loader"
                  [idsData]="sensorTabeData"
                  [client_id]="client_id"
                ></app-powertrain-sensors-table>
              </div>
              <div
                class="border_wrapper health_status_alarms_box"
                style="width: 40%"
              >
                <app-powertrain-healthbar
                  *ngIf="!loader"
                  [asset_ids]="assetIds"
                  [mac_addresses]="mac_addresses"
                  [client_id]="client_id"
                ></app-powertrain-healthbar>
                <app-powertrain-alerts
                  *ngIf="!loader"
                  [client_id]="client_id"
                  [assetInventoryIds]="assetInventoryIds"
                  [subsystem_id]="subsystem_id"
                ></app-powertrain-alerts>
              </div>
            </div>
            <div
              class="mt-4 d-flex align-items-stretch pt-cards-wrapper"
              style="width: 98%; margin-left: 20px"
            >
              <app-powertrain-operational-kpi
                *ngIf="!loader"
                [mac_address]="masterMacaddress"
                [client_id]="client_id"
                class="flex_20"
              ></app-powertrain-operational-kpi>
              <app-powertrain-performance
                *ngIf="!loader"
                [subsystem_id]="subsystem_id"
                [client_id]="client_id"
                [commission_date]="commission_date"
                class="flex_20"
              ></app-powertrain-performance>
              <app-powertrain-ytd-savings
                *ngIf="!loader"
                [subsystem_id]="subsystem_id"
                [client_id]="client_id"
                class="flex_20"
              ></app-powertrain-ytd-savings>

              <app-powertrain-flase-claims
                *ngIf="!loader"
                [subsystem_id]="subsystem_id"
                [client_id]="client_id"
                class="flex_20"
              ></app-powertrain-flase-claims>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 20px"
              *ngIf="client_id == 390"
            >
              <button
                mat-raised-button
                color="primary"
                (click)="toggleTrends()"
              >
                {{
                  showTrendsChart ? "Hide Trends Chart" : "Show Trends Chart"
                }}
              </button>
            </div>
            <ng-container *ngIf="showTrendsChart && !loader && client_id == 390">
              <app-stacked-line-chart
                [assetInventoryIds]="assetInventoryIds"
                [graphType]="graphType[0]"
              ></app-stacked-line-chart>
              <app-stacked-line-chart
                [assetInventoryIds]="assetInventoryIds"
                [graphType]="graphType[1]"
              ></app-stacked-line-chart>
              <app-stacked-line-chart
                [assetInventoryIds]="assetInventoryIds"
                [graphType]="graphType[2]"
              ></app-stacked-line-chart>
              <app-stacked-line-chart
                [assetInventoryIds]="assetInventoryIds"
                [graphType]="graphType[3]"
              ></app-stacked-line-chart>
              <app-stacked-line-chart
                [assetInventoryIds]="assetInventoryIds"
                [graphType]="graphType[4]"
              ></app-stacked-line-chart>
            </ng-container>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="ctdTabset"></div>
    </div>
  </div>
</div>

<app-powertrain-modal
  [type]="'delete_powertrain'"
  *ngIf="showModal"
  (closeBox)="onDeleteModalResponse($event)"
></app-powertrain-modal>

<app-powertrain-modal
  [type]="'plate_details'"
  *ngIf="showPlateDetailsModal"
  [data]="{ subsystem_id: subsystem_id, subsystem_name: powertrain_name }"
  (closePlateDetailsModal)="closePlateDetailsModal($event)"
></app-powertrain-modal>

<div
  class="delete_loader"
  style="width: 100vw; height: 100vh; z-index: 1000"
  *ngIf="showDeleteLoader"
></div>
